import styled, { css } from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const red = css`
  background: ${({
  theme
}) => theme.primary.main};

  h2 {
    &:after {
      border-bottom: 4px solid ${({
  theme
}) => theme.secondary.main};
    }
  }
`;
export const black = css`
  background: ${({
  theme
}) => theme.secondary.main};

  h2 {
    &:after {
      border-bottom: 4px solid ${({
  theme
}) => theme.primary.main};
    }
  }
`;
export const StyledBaseCardWrapper = css`
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
  height: 100%;
  margin-bottom: 0;
  border: 0 solid ${({
  theme
}) => theme.tertiary.main};
  border-width: ${props => props.hasBodyBackground ? '1px' : '0'};
  ${props => props.backgroundColor === 'red' && red}
  ${props => props.backgroundColor === 'black' && black}
  z-index: 1;
  width: 100%;
  border: ${({
  smWithBorder,
  theme
}) => smWithBorder && `1px solid ${theme.tertiary.dark}`};

  ${breakpoints.md} {
    border: none;
    flex-direction: column;
    justify-content: ${props => props.isBodyTop ? 'space-between' : 'flex-end'};
    min-height: 329px;
  }

  ${breakpoints.lg} {
    min-height: ${props => props.minHeightLg ? props.minHeightLg : '329px'};
  }

  &:hover {
    ${breakpoints.md} {
      h2:after {
        content: '';
        margin: 16px 0;
        transform: scaleX(1);
        transform-origin: left center;
        transition: all 0.2s ease-in-out;
      }
    }
  }

  ${props => props.wide ? `
    &:after {
      content: '';
      display: block;
      height: 100%;
      width: 100%;
      position: absolute;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.7)
      );
    }` : `${breakpoints.md} {
    &:after {
      content: '';
      display: block;
      height: 100%;
      width: 100%;
      position: absolute;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.7)
      );
    }}
`}
`;
export const BaseCardTag = styled.div`
  display: none;

  ${breakpoints.md} {
    display: block;
    width: calc(100% - 40px);
    margin: 0 20px;
    align-items: flex-start;
  }
`;
export const BaseCardIconBox = styled.div`
  position: absolute;
  top: 0px;
  left: ${props => props.wide ? 'auto' : '80px'};
  right: ${props => props.wide ? '0' : 'auto'};
  height: 32px;
  width: 32px;
  background-color: ${({
  theme
}) => theme.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;

  ${breakpoints.md} {
    right: 0px;
    left: auto;
  }
`;